import {ComponentData} from "../../engine/tools/EntityManager";
import {AnimationId} from "../animation/animationPlayer";

export enum SCENE_STATE {
    NONE = "none",
    FALLING = "falling",
    INTERACTIVE = "interactive",
    TRANSITION_IN = "transition_in",
    TRANSITION_OUT = "transition_out",
    WAIT_FOR_TRANSITION = "wait_for_transition",
}

class SceneAnimationStateDefinition{
    mainAnimation: AnimationId | AnimationId[]
    transitionInAnimation: AnimationId
    transitionOutAnimation: AnimationId
    minLoopCount?: number
    maxLoopCount?: number
    releaseFrameId: number | number[]
    showTransitionOnLoop?: boolean
}


export class SceneStateManager implements ComponentData {

    constructor(options: Partial<SceneStateManager> = {}) {

        Object.assign(this, options)
    }

    currentState: SCENE_STATE = SCENE_STATE.NONE
    targetState: SCENE_STATE = SCENE_STATE.NONE
    stateTime: number = 0
    animations: SceneAnimationStateDefinition[]
    animationId: number = 0
    animationSubId: number = 0
    remainingLoops: number = 0
}